// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as R from 'ramda'
import { forkJoin, of } from 'rxjs'
import { filter, mergeMap, switchMap, tap } from 'rxjs/operators'

import { DATA_USER_CONNECT } from '@weblite/action/gateway'
import { DATA_AUTH_SIGNOUT } from '@weblite/action/auth'
import { sendBecomeOnline } from '@weblite/ts-action/gateway'

import { serverSub } from '$func/subscription'
import { fromObservable } from '$func/effectUtils'
import {
  dispatchSetConnectionStatus,
  SET_CONNECTION_STATUS,
} from '$comp/main/root.action'
// import { connectionReport } from './helper'
import { sendSocketConnectedEventToWapps } from '$logic/wapp-subscribed-topics'
import { retryUntilSucceedWithCancel$ } from '$func/retryFunction'
import { changeConnectionStatus, sendNow } from '$setup/ws'
import { Feature, features } from '$setup/features'
import { delayedSyncFuncs, immediateSyncFuncs } from './sync-functions'
import afterSignOut from '../../hooks/after/signout'
import { webSocketConnectionEstablishmentReporter } from '$hooks/after/connection'
import {
  createUserWaitReporter,
  UserWaitPendingAction,
} from '$logic/analytics/reporters/user-wait'
import { createCallbackManager } from '$func/callbacks'
import { authStorage } from '$logic/auth/storage'
import { saveSignOutByServerAnalyticsEventToRam } from '$logic/auth/sign-out-analytics'

export const updateAppUserWaitReporter = createUserWaitReporter(
  UserWaitPendingAction.UPDATE_APP,
  undefined,
  undefined,
  undefined,
  5000,
)

export const connectionCallbackManager = createCallbackManager()

serverSub.subscribeToAll(
  fromObservable(action$ =>
    action$.pipe(
      filter(R.propEq('type', DATA_USER_CONNECT)),
      tap(() => {
        webSocketConnectionEstablishmentReporter.end()
        updateAppUserWaitReporter.start()

        dispatchSetConnectionStatus('updating')

        sendSocketConnectedEventToWapps()
        // connectionReport.setUpdating()
      }),
      switchMap(() =>
        of(immediateSyncFuncs).pipe(
          mergeMap(syncFuncs =>
            forkJoin(
              syncFuncs.map(syncFunc =>
                retryUntilSucceedWithCancel$(
                  syncFunc,
                  action$.pipe(filter(R.propEq('type', SET_CONNECTION_STATUS))),
                ),
              ),
            ),
          ),
        ),
      ),
      tap(() => {
        dispatchSetConnectionStatus('connected')

        connectionCallbackManager.runCallbacks()

        updateAppUserWaitReporter.end()

        if (features.has(Feature.DELAYED_ONLINE_STATUS)) {
          sendNow(sendBecomeOnline)
        }

        delayedSyncFuncs.forEach(func => func())
        changeConnectionStatus()
      }),
    ),
  ),
)

serverSub.subscribe(DATA_AUTH_SIGNOUT, () => {
  const auth = authStorage.get()
  saveSignOutByServerAnalyticsEventToRam(auth?.userId)
  afterSignOut()
})
